/**
 * @desc: - 公告走马灯
 * @param  {[string]} list           [需要展示的列表数据]
 * @param  {[number]} onMore         [用户点击更多的回调，无参数]
 * @param  {[number]} onItemClick    [用户点击公告条目，参数为公告的id]
 * @author: danny
 */

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
// import '../../../src/styles/themes/hy-day/marquee.scss'

import ReactDOM from "react-dom";


export default class Marquee extends React.Component {
  constructor(props) {
    super(props);
    //为方法 绑定this
    this.monitor = this.monitor.bind(this);

    // 当前显示图片index current 为-1 ，刚开始播放时的第一张图片也是从底部滚动起来
    this.state = {
      current: -1,
      duration: 0.5,
      list: []
    }

  }

  componentWillReceiveProps(nextProps) {
    //判断是否已经接收到 广播数据
    if (nextProps.list && nextProps.list.length > 0 && this.state.list.length == 0) {
      //在数组末尾添加原始数据第0个元素，在整个列表滚动完切换的时候不会有跳跃的感觉

      nextProps.list.push(nextProps.list[0]);
      //刷新页面
      this.setState({
        list: nextProps.list
      });
      // 开始自动轮播
      this.autoPalyFlag = setInterval(() => {
        this.turn(1);
      }, 3000);
      this._listDom = ReactDOM.findDOMNode(this.refs.mergre);
      if (this._listDom) {
        this._listDom.addEventListener('webkitTransitionEnd', this.monitor)
      }
    }
  }
  monitor() {
    //如果只有一条数据 就不用切换了,props 修改为state
    if (this.state.list.length <= 1) return;
    //当切换到倒数第二个时候，事实上已经切换到原始数组的最后一个。
    //此时，将整个列表复位 即marginTop 0，duration为0
    //由于两个item(第一个，最后一个【自己添加进去的 CompomentwillRecieveProps】)是一样的，不会有跳跃的感觉
    if (this.state.current == this.state.list.length - 1) {
      this.setState({duration: 0})
      this.setState({current: 0})
    }
  }
  // 销毁自动滚动定时器，注销监听事件
  componentWillUnmount() {
    clearInterval(this.autoPalyFlag);
    if (this._listDom) {
      this._listDom.removeEventListener('webkitTransitionEnd', this.monitor);
    }
  }

  // 自动切换
  turn(n) {
    const {list} = this.state;
    let _n = this.state.current + n;
    if (_n == list.length + 1) {
      this.setState({duration: 0})
    } else {
      this.setState({duration: 0.5})
    }
    if (_n < list.length + 1 && _n >= 0) {
      this.setState({current: _n})
    } else {
      if (_n == -1) {
        this.setState({current: list.length - 1})
        return;
      }
      this.setState({current: 0})
    }
  }

  render() {
    const {onMore, onItemClick} = this.props;
    return (<div className="marquee-container">
          <div className="center-warp">
            <div className="notice-icon"/>
            {/*计算list 滚动到某个位置，还有滚动的速度，最后一个item时 marginTop为0 立即复位，以从新开始滚动*/}
            <div ref='mergre' className="list-warp" style={{
              marginTop: (this.props.scrollH) * -1 * this.state.current,
              transitionDuration: this.state.duration + 's'
            }}>
              {
                this.state.list.map((item, i) => {
                  return <div onClick={() => {
                    onMore(item)
                  }} className="item" key={i}>{item.title}</div>
                })
              }
            </div>
            <div className="more-notice" onClick={() => {
              onMore(null)
            }}>更多
            </div>
          </div>
        </div>
    );
  }
}